import { Controller } from '@hotwired/stimulus';
import Leaflet from 'leaflet';
import "leaflet.markercluster";
import markerUrl from '../../images/icons/pins/pin-plus.svg';

export default class extends Controller {
    static values = {
        centerCoords: String,
        clubs: Array,
        zoom: Number,
    }
    connect() {
        const mapElement = this.element.querySelector('.map');
        const center = mapElement.dataset.center.split(',');
        this.clubs = JSON.parse(mapElement.dataset.clubs);
        this.markersReference = {};
        const zoom = mapElement.dataset.zoom;
        const iconOptions = {
            title: "Title",
            icon: new (Leaflet.Icon.extend({
                options: {
                    iconSize: [41, 51],
                    iconAnchor: [21, 44],
                },
            }))({iconUrl: markerUrl}),
        }

        const popupOptions = {
            minWidth: 190,
            maxWidth: 190,
            className: 'club-popup',
            closeButton: false,
        }

        this.map = Leaflet.map(mapElement, {
            center: center,
            zoom: zoom,
            scrollWheelZoom: false,
            dragging: !Leaflet.Browser.mobile,
            // zoomControl: true,
            // closePopupOnClick: false,
            // touchZoom: false,
            // doubleClickZoom: false,
            // trackResize: false,
        });

        // Leaflet.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{tileSize}/{z}/{x}/{y}?access_token={accessToken}', {
        //     attribution: '© <a href="https://www.mapbox.com/contribute/">Mapbox</a>',
        //     id: 'cpartner/clg3una76001t01qj2asizfoa',
        //     tileSize: 512,
        //     zoomOffset: -1,
        //     accessToken: 'pk.eyJ1IjoiY3BhcnRuZXIiLCJhIjoiY2xpY3o1bDltMGdpbjNzbXFhMXlnb2RpeSJ9.pFX4K96Pu_L9YLT6N54K_A',
        // }).addTo(map);

        Leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: ''
        }).addTo(this.map);

        let markers = Leaflet.markerClusterGroup({
            maxClusterRadius: 30
        });

        this.clubs.forEach((club) => {
            iconOptions.title = club.title;
            let marker = Leaflet.marker(club.coordinates, iconOptions);
            let customPopup = `
                <img class="club-popup__image" src="${club.image}" alt="Club image"/>
                <div class="club-popup__title">${club.title}</div>
            `;
            if (club.btn_url && club.btn_title) {
                customPopup += `<a class="club-popup__button" href="${club.btn_url}">${club.btn_title}</a>`;
            }

            marker.bindPopup(customPopup, popupOptions);
            markers.addLayer(marker);

            this.markersReference[club.title] = marker;
        })

        this.map.addLayer(markers);
    }

    focusOnMarker(event) {
        let data = event.currentTarget.dataset;
        let coordinates = [data.lat, data.long];
        this.map.flyTo(coordinates, 16);

        this.element.querySelectorAll('.club-item').forEach((el)=>{
            el.classList.remove('active');
        });
        event.currentTarget.classList.add('active');
    }

    findClubByAddress(event) {
        console.log('Finding club...')
        const submit = event.currentTarget;
        const address = document.getElementById('addressInput').value;
        const error = this.element.querySelector('.general-error');

        submit.classList.add('loading');
        error.classList.add('d-none');

        if (!address) {
            console.log("Address input is empty. Aborting search.");
            submit.classList.remove('loading');
            error.classList.remove('d-none');
            return;
        }

        const geocodingUrl = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=pk.eyJ1Ijoib2dpbnNrYXNkIiwiYSI6ImNreDNtdzgxaTIwZ24ycHFycnVsa295NmoifQ.HFDL1bkuvIc3u396YqrVEA`;

        fetch(geocodingUrl)
            .then(response => response.json())
            .then(data => {
                if (data.features && data.features.length > 0) {
                    const coords = data.features[0].geometry.coordinates;
                    this.handlePosition({ coords: { latitude: coords[1], longitude: coords[0] } });
                } else {
                    console.error("Couldn't find the address.");
                    error.classList.remove('d-none');
                }
                submit.classList.remove('loading');
            })
            .catch(error => {
                console.error("Error geocoding address:", error);
                submit.classList.remove('loading');
                error.classList.remove('d-none');
            });
    }

    findClosestClub() {
        if (!this.clubs) {
            console.error("Clubs data is not available.");
            return;
        }

        let closestClub = null;
        let shortestDistance = Infinity;

        this.clubs.forEach(club => {
            let clubLocation = Leaflet.latLng(club.coordinates);
            let distance = this.map.distance(this.userLocation, clubLocation);

            if (distance < shortestDistance) {
                shortestDistance = distance;
                closestClub = club;
            }
        });

        if (closestClub) {
            this.focusOnClosestClub(closestClub);
        }
    }

    focusOnClosestClub(club) {
        this.map.once('moveend', () => {
            const marker = this.markersReference[club.title];
            if (marker) {
                marker.openPopup();
            }

            const clubItemIndex = this.getClubItemIndex(club.title);
            console.log(this.sliderController)
            if (clubItemIndex !== -1 && this.sliderController) {
                this.sliderController.slideTo(clubItemIndex);
                this.setActiveClubItem(club.title);
            }
        });

        this.map.flyTo(club.coordinates, 16);
    }

    getClubItemIndex(clubTitle) {
        const clubItems = Array.from(this.element.querySelectorAll('.club-item'));
        return clubItems.findIndex(item => item.dataset.clubTitle === clubTitle);
    }

    setActiveClubItem(clubTitle) {
        this.element.querySelectorAll('.club-item').forEach((item) => {
            item.classList.remove('active');
        });

        const clubItem = this.element.querySelector(`.club-item[data-club-title="${clubTitle}"]`);
        if (clubItem) {
            clubItem.classList.add('active');
        }
    }


    get sliderController() {
        const sliderElement = this.element.querySelector('.swiper');
        return this.application.getControllerForElementAndIdentifier(sliderElement, "slider");
    }

    getCurrentLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.handlePosition.bind(this), this.handleError.bind(this));
        } else {
            console.error("Geolocation is not supported by this browser.");
        }
    }

    handlePosition(position) {
        this.userLocation = [position.coords.latitude, position.coords.longitude];
        this.findClosestClub();
    }

    handleError(error) {
        console.error("Error retrieving location:", error);
    }
}
